export const pleaseChoose: string = "Bitte auswählen..";
